import React from "react";
import "./IsoCertificatesSection.css";
import { useTranslation } from 'react-i18next';

import isoBg from "../../assets/certificates/iso-bg.jpg";

import thumb1 from "../../assets/certificates/certificate1.png";
import thumb2 from "../../assets/certificates/certificate2.png";
import thumb3 from "../../assets/certificates/certificate3.png";

import full1 from "../../assets/certificates/iso-certificate1.jpg";
import full2 from "../../assets/certificates/iso-certificate2.jpg";
import full3 from "../../assets/certificates/iso-certificate3.jpg";

const IsoCertificatesSection = ({ setLightbox }) => {
  const { t } = useTranslation();

  const certificates = [
    {
      thumb: thumb1,
      full: full1,
      title: t('certificates.cert1.title'),
      location: t('certificates.cert1.location'),
      year: t('certificates.cert1.year')
    },
    {
      thumb: thumb2,
      full: full2,
      title: t('certificates.cert2.title'),
      location: t('certificates.cert2.location'),
      year: t('certificates.cert2.year')
    },
    {
      thumb: thumb3,
      full: full3,
      title: t('certificates.cert3.title'),
      location: t('certificates.cert3.location'),
      year: t('certificates.cert3.year')
    }
  ];

  const openLightbox = (cert) => {
    setLightbox({
      isOpen: true,
      images: [cert.full],
      currentIndex: 0,
      title: cert.title,
      location: cert.location,
      year: cert.year
    });
  };

  return (
    <div
      className="iso-section"
      style={{
        backgroundImage: `url(${isoBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "80px 0",
        textAlign: "center",
      }}
    >
      <h2 className="iso-title">{t('certificates.title')}</h2>
      <div className="certificates-container">
        {certificates.map((cert, index) => (
          <div key={index} className="certificate-item">
            <img
              src={cert.thumb}
              alt={t('certificates.logoAlt', { number: index + 1 })}
              className="certificate-thumbnail"
              onClick={() => openLightbox(cert)}
              loading="lazy"
            />
            <p className="certificate-caption">{cert.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IsoCertificatesSection;